export default "/fonts/vendor/@coreui/icons/CoreUI-Icons-Free.ttf?68d6a47af77c11c4dc8b625fbf99b6ed";